/**
 * Exponential-backoff-with-jitter reconnect helper.
 *
 * Used by `ManagedMqtt` (replacing the old `rmf-ws.ts` implementation) and
 * any future transport that needs the same disconnect recovery. Centralised
 * here so a tuning change is a one-file edit.
 */
const DEFAULT_BASE_MS = 500;
const DEFAULT_MAX_MS = 30_000;
const DEFAULT_JITTER_MS = 250;

export function nextReconnectDelay(
  attempt: number,
  baseMs: number = DEFAULT_BASE_MS,
  maxMs: number = DEFAULT_MAX_MS,
  jitterMs: number = DEFAULT_JITTER_MS,
  random: () => number = Math.random,
): number {
  const exp = Math.min(maxMs, baseMs * 2 ** attempt);
  return exp + random() * jitterMs;
}
